"use client";

import { memo, type ReactNode } from "react";
import dynamic from "next/dynamic";
import styles from "./HeroSectionHomeNew.module.scss";
import Globe from "@/SvgIcons/Globe";
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";
import CustomHeroProgramSlider from "@/components/molecules/CustomHeroProgramSlider/CustomHeroProgramSlider";
import HeroProgramSectionSliders from "@/components/molecules/Carousels/HeroSlideRevamp/HeroProgramSectionSliders";

const CTARow = dynamic(() => import("./CTARow"), {
  loading: () => <div aria-hidden style={{ minHeight: 48, width: "100%" }} />,
});

interface SliderDataProps {
  Image: string;
  Title: string;
  SubTitle: string;
  slug: string;
}

interface HeroSectionHomeNewProps {
  sliderData: SliderDataProps[];
  associatedPrograms: any;
  isMobile?: boolean;
  /** Server-rendered LCP <img> (matches root layout preload href). */
  lcpMedia?: ReactNode;
}

const BadgeRow: React.FC = () => (
  <div className={styles.badgeRow}>
    <span className={styles.badge}>
      <UnivoImage
        src={IMAGE_ASSETS.heroUgcBadge}
        alt="UGC"
        width={18}
        height={18}
        sizes="18px"
        className={styles.badgeIcon}
        loading="eager"
        style={{ width: 18, height: 18 }}
      />
      UGC Entitled
    </span>
    <span className={styles.mid}> | </span>
    <span className={styles.badge}>
      <Globe />
      Globally Recognized
    </span>
  </div>
);

const HeroHeading: React.FC = () => (
  <h1 className={styles.heroHeading}>
    THE WORLD’S <br /> DIGITAL CAMPUS
  </h1>
);

const FeatureRow: React.FC = () => (
  <div className={styles.featureRow}>FOR EVERYONE, EVERYWHERE.</div>
);

const HeroSectionHomeNew: React.FC<HeroSectionHomeNewProps> = ({
  sliderData,
  associatedPrograms,
  isMobile = false,
  lcpMedia,
}) => {
  return (
    <section className={styles.heroSection} data-section="hero">
      {isMobile && lcpMedia}
      <div className={styles.heroContainer}>
        <div className={styles.heroLeft}>
          <div className={styles.mobileCard}>
            <BadgeRow />
            <HeroHeading />
            <FeatureRow />
            <div className={styles.programSliderSlot}>
              {isMobile ? (
                <CustomHeroProgramSlider sliderData={sliderData} />
              ) : (
                <HeroProgramSectionSliders sliderData={sliderData} />
              )}
            </div>
            <CTARow associatedPrograms={associatedPrograms} />
          </div>
        </div>
        {!isMobile && lcpMedia}
      </div>
    </section>
  );
};

export default memo(HeroSectionHomeNew);
